import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'hash',
  routes: [
    {
      path: '/',
      component: () => import('@/layout/index.vue'),
      meta: { requiresAuth: true },
      children: [
        { path: '', redirect: '/dashboard' },
        {
          path: 'dashboard',
          name: 'dashboard',
          component: () => import('@/views/dashboard/index.vue'),
          meta: { title: '角色工作台', requiresAuth: true },
        },
        {
          path: 'orders',
          name: 'orders',
          component: () => import('@/views/orders/OrderList.vue'),
          meta: { title: '工单管理', requiresAuth: true },
        },
        {
          path: 'workflow/:id?',
          name: 'workflow',
          component: () => import('@/views/workflow/index.vue'),
          meta: { title: 'OA 审核流程', requiresAuth: true },
        },
        {
          path: 'performance',
          name: 'performance',
          component: () => import('@/views/performance/index.vue'),
          meta: { title: '维修排行榜', requiresAuth: true },
        },
        {
          path: 'analytics',
          name: 'analytics',
          component: () => import('@/views/analytics/index.vue'),
          meta: { title: '数据分析', requiresAuth: true },
        },
        {
          path: 'wechat-identities',
          name: 'wechat-identities',
          component: () => import('@/views/system/WechatIdentityList.vue'),
          meta: { title: '微信身份管理', requiresAuth: true, roles: ['system_admin'] },
        },

        {
          path: 'menu-permissions',
          name: 'menu-permissions',
          component: () => import('@/views/system/MenuPermissionList.vue'),
          meta: { title: '菜单权限', requiresAuth: true, roles: ['system_admin'] },
        },
        {
          path: 'wechat-groups',
          name: 'wechat-groups',
          component: () => import('@/views/system/WechatGroupList.vue'),
          meta: { title: '企业微信群聊', requiresAuth: true, roles: ['system_admin'] },
        },
        {
          path: 'dispatch-areas',
          name: 'dispatch-areas',
          component: () => import('@/views/system/DispatchAreaList.vue'),
          meta: { title: '派工区域', requiresAuth: true, roles: ['admin', 'maintenance', 'system_admin'] },
        },
        {
          path: 'type-company-routes',
          name: 'type-company-routes',
          component: () => import('@/views/system/TypeCompanyRouteList.vue'),
          meta: { title: '类型对应公司', requiresAuth: true, roles: ['admin', 'maintenance', 'system_admin'] },
        },

        {
          path: 'repair-materials',
          name: 'repair-materials',
          component: () => import('@/views/system/RepairMaterialList.vue'),
          meta: { title: '耗材管理', requiresAuth: true, roles: ['admin', 'maintenance', 'system_admin'] },
        },
        {
          path: 'repair-categories',
          name: 'repair-categories',
          component: () => import('@/views/system/RepairCategoryList.vue'),
          meta: { title: '报修分类', requiresAuth: true, roles: ['admin', 'maintenance', 'system_admin'] },
        },
        {
          path: 'repair-locations',
          name: 'repair-locations',
          component: () => import('@/views/system/RepairLocationList.vue'),
          meta: { title: '报修位置', requiresAuth: true, roles: ['admin', 'maintenance', 'system_admin'] },
        },
        {
          path: 'complaints',
          name: 'complaints',
          component: () => import('@/views/system/ComplaintList.vue'),
          meta: { title: '投诉处理', requiresAuth: true, roles: ['maintenance', 'admin', 'system_admin'] },
        },
        {
          path: 'worker-accounts',
          name: 'worker-accounts',
          component: () => import('@/views/system/WorkerAccountList.vue'),
          meta: { title: '维修工账号', requiresAuth: true, roles: ['admin', 'maintenance', 'system_admin'] },
        },
        {
          path: 'accounts',
          name: 'accounts',
          component: () => import('@/views/system/AccountList.vue'),
          meta: { title: '账号管理', requiresAuth: true, roles: ['admin', 'maintenance', 'system_admin'] },
        },
        {
          path: 'dispatch-board',
          name: 'dispatch-board',
          component: () => import('@/views/orders/DispatchBoard.vue'),
          meta: { title: '待接单派单', requiresAuth: true, roles: ['admin', 'maintenance', 'system_admin'] },
        },
        {
          path: 'dispatch-reminders',
          name: 'dispatch-reminders',
          component: () => import('@/views/system/DispatchReminderList.vue'),
          meta: { title: '接单监控', requiresAuth: true, roles: ['admin', 'maintenance', 'system_admin'] },
        },
        {
          path: 'orders/:id/print',
          name: 'order-print',
          component: () => import('@/views/orders/OrderPrint.vue'),
          meta: { title: '结单单据', requiresAuth: true, roles: ['maintenance'] },
        },
      ],
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login/index.vue'),
      meta: { title: '登录' },
    },
    { path: '*', redirect: '/dashboard' },
  ],
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title ? `${to.meta.title} - 怀化学院码上修` : '怀化学院码上修管理后台'
  if (to.matched.some((record) => record.meta.requiresAuth) && !store.getters.isAuthenticated) {
    next({ path: '/login', query: { redirect: to.fullPath } })
    return
  }
  if (to.path === '/login' && store.getters.isAuthenticated) {
    next('/dashboard')
    return
  }
  const roleRoute = to.matched.find((record) => Array.isArray(record.meta.roles))
  if (roleRoute && !roleRoute.meta.roles.includes(store.getters.role)) {
    next('/dashboard')
    return
  }
  next()
})

export default router

